var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "product_body" },
        [
          _c("hotel-resource-left", {
            attrs: {
              btnName: _vm.butName,
              btnName1: _vm.productObj.fromInquiryId ? "" : "抢",
              productObj: _vm.productObj,
            },
            on: {
              addReferBudget: _vm.addReferBudget,
              exclusiveAddYsP: _vm.exclusiveAddYsP,
            },
          }),
          _c(
            "div",
            { class: _vm.productObj.isOpen ? "hidenDiv" : "hidenDivTwo" },
            [
              _vm.productObj.state != 6
                ? _c(
                    "div",
                    _vm._l(
                      _vm.productObj.stockListResults,
                      function (item, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "hiden_item" },
                          [
                            _c("div", [
                              _c(
                                "p",
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      staticStyle: { "margin-top": "0.15rem" },
                                      on: {
                                        change: function ($event) {
                                          return _vm.checkItem(item)
                                        },
                                      },
                                      model: {
                                        value: item.checkBox,
                                        callback: function ($$v) {
                                          _vm.$set(item, "checkBox", $$v)
                                        },
                                        expression: "item.checkBox",
                                      },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(item.productNameCn)),
                                      ]),
                                      item.productDesc != ""
                                        ? _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-size": "0.12rem",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "(" +
                                                  _vm._s(item.productDesc) +
                                                  ")"
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      item.mergerPurchase &&
                                      item.mergerPurchase != ""
                                        ? _c("span", { staticClass: "label" }, [
                                            _vm._v("不可拆分购买"),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]),
                            _c(
                              "div",
                              { staticStyle: { "margin-left": "0.25rem" } },
                              [
                                _c(
                                  "p",
                                  { staticStyle: { "margin-top": "0.08rem" } },
                                  [
                                    item.recommendation != ""
                                      ? _c("i", {
                                          staticClass: "icon-aixin iconfont",
                                          staticStyle: { color: "#D81B43" },
                                        })
                                      : _vm._e(),
                                    item.recommendation != ""
                                      ? _c(
                                          "label",
                                          { staticClass: "recommendation" },
                                          [_vm._v(_vm._s(item.recommendation))]
                                        )
                                      : _vm._e(),
                                    item.recommendation != ""
                                      ? _c(
                                          "label",
                                          {
                                            staticStyle: {
                                              color: "#D9D9D9",
                                              "margin-right": "0.04rem",
                                            },
                                          },
                                          [_vm._v("|")]
                                        )
                                      : _vm._e(),
                                    item.stockDesc != ""
                                      ? _c(
                                          "label",
                                          { staticClass: "recommendation" },
                                          [_vm._v(_vm._s(item.stockDesc))]
                                        )
                                      : _vm._e(),
                                    item.cityTaxPrice
                                      ? _c(
                                          "label",
                                          { staticClass: "recommendation" },
                                          [
                                            _vm._v(
                                              "城市税:" +
                                                _vm._s(item.cityTaxPrice) +
                                                _vm._s(
                                                  item.priceList[0].currency
                                                ) +
                                                "/" +
                                                _vm._s(item.cityTaxCompany)
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    item.stockDesc != "" || item.cityTaxPrice
                                      ? _c(
                                          "label",
                                          {
                                            staticStyle: {
                                              color: "#D9D9D9",
                                              "margin-right": "0.04rem",
                                            },
                                          },
                                          [_vm._v("|")]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "label",
                                      {
                                        staticStyle: {
                                          color: "#155969",
                                          "font-weight": "bold",
                                        },
                                      },
                                      [
                                        _c("label", [
                                          _vm._v(
                                            _vm._s(
                                              item.cancelType == 1
                                                ? "不可取消"
                                                : "有条件退"
                                            ) + " "
                                          ),
                                        ]),
                                        _vm._v(" / "),
                                        _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              content:
                                                item.isShareOption &&
                                                item.isShareOption == 1
                                                  ? "下单后需资源方二次确认"
                                                  : "在option有效期内下订单，订单可自动确认",
                                              effect: "dark",
                                              placement: "top",
                                            },
                                          },
                                          [
                                            _c("label", [
                                              item.isShareOption &&
                                              item.isShareOption == 1
                                                ? _c("label", [
                                                    _vm._v("Shared "),
                                                  ])
                                                : _vm._e(),
                                              _c("label", [
                                                _vm._v(
                                                  "Option " +
                                                    _vm._s(
                                                      _vm.dateFormatYMD(
                                                        item.optionTime,
                                                        "."
                                                      )
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm.dateFormatHM(
                                                        item.optionTime
                                                      )
                                                    )
                                                ),
                                              ]),
                                            ]),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._l(item.priceList, function (p, i) {
                                  return _c(
                                    "p",
                                    {
                                      key: i,
                                      staticStyle: { "margin-top": "0.06rem" },
                                    },
                                    [
                                      _c("label", [
                                        p.startDate != ""
                                          ? _c("span", [
                                              _vm._v(_vm._s(p.startDate)),
                                            ])
                                          : _vm._e(),
                                        p.endDate !== "" &&
                                        p.endDate !== p.startDate
                                          ? _c(
                                              "label",
                                              {
                                                staticStyle: {
                                                  color: "#959090",
                                                  "margin-right": "0.05rem",
                                                  "font-weight": "bold",
                                                },
                                              },
                                              [_vm._v("至")]
                                            )
                                          : _vm._e(),
                                        p.endDate !== "" &&
                                        p.endDate !== p.startDate
                                          ? _c("span", [
                                              _vm._v(_vm._s(p.endDate)),
                                            ])
                                          : _vm._e(),
                                      ]),
                                      _c(
                                        "label",
                                        { staticStyle: { color: "#E64A19" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.butName == "加入报价"
                                                ? "报价"
                                                : "成本"
                                            ) + " "
                                          ),
                                        ]
                                      ),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(p.price) +
                                            _vm._s(p.currency) +
                                            "/" +
                                            _vm._s(p.priceCompany) +
                                            "/" +
                                            _vm._s(p.useTime)
                                        ),
                                      ]),
                                      _vm.addPriceFlag
                                        ? [
                                            _c(
                                              "label",
                                              {
                                                staticStyle: {
                                                  color: "#E64A19",
                                                },
                                              },
                                              [_vm._v(" 报价 ")]
                                            ),
                                            _c(
                                              "span",
                                              [
                                                _c("el-input", {
                                                  staticStyle: {
                                                    width: "120px",
                                                  },
                                                  attrs: { size: "mini" },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.changePrice(
                                                        item
                                                      )
                                                    },
                                                    input: function ($event) {
                                                      return _vm.handleInput(
                                                        $event,
                                                        item
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value: item.ratio,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "ratio",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "item.ratio",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        : _vm._e(),
                                      _vm.productObj.fromInquiryId &&
                                      !_vm.addPriceFlag &&
                                      p.toCPrice != 0
                                        ? [
                                            _c(
                                              "label",
                                              {
                                                staticStyle: {
                                                  color: "#E64A19",
                                                  "font-size": "14px",
                                                },
                                              },
                                              [_vm._v(" 报价 ")]
                                            ),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(p.toCPrice) +
                                                  _vm._s(p.currency) +
                                                  "/" +
                                                  _vm._s(p.priceCompany) +
                                                  "/" +
                                                  _vm._s(p.useTime)
                                              ),
                                            ]),
                                          ]
                                        : _vm._e(),
                                      p.marketPrice != ""
                                        ? _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-size": "0.12rem",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " （市价：" +
                                                  _vm._s(p.marketPrice) +
                                                  _vm._s(p.currency) +
                                                  "） "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(p.number) +
                                            _vm._s(p.priceCompany)
                                        ),
                                      ]),
                                      p.useTime &&
                                      p.useTime != "" &&
                                      item.state == 0
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getBetweenDay([
                                                  p.startDate,
                                                  p.endDate,
                                                ])
                                              ) + _vm._s(p.useTime)
                                            ),
                                          ])
                                        : _vm._e(),
                                      p.useTime &&
                                      p.useTime != "" &&
                                      item.state != 0
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getBetweenDay([
                                                  p.startDate,
                                                  p.endDate,
                                                ]) + 1
                                              ) + _vm._s(p.useTime)
                                            ),
                                          ])
                                        : _vm._e(),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "margin-right": "-4px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.butName == "加入报价"
                                                ? ""
                                                : "成本"
                                            ) + "共 "
                                          ),
                                        ]
                                      ),
                                      item.state == 0
                                        ? _c(
                                            "span",
                                            { staticClass: "orangeFont" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    Number(
                                                      (
                                                        p.price *
                                                        p.number *
                                                        _vm.getBetweenDay([
                                                          p.startDate,
                                                          p.endDate,
                                                        ])
                                                      ).toFixed(2)
                                                    )
                                                  ) +
                                                  _vm._s(p.currency) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "span",
                                            { staticClass: "orangeFont" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    p.price *
                                                      p.number *
                                                      (_vm.getBetweenDay([
                                                        p.startDate,
                                                        p.endDate,
                                                      ]) +
                                                        1)
                                                  ) +
                                                  _vm._s(p.currency) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                      p.toCPrice && p.toCPrice > 0
                                        ? _c("span", [
                                            _c("span", [_vm._v(" 报价共 ")]),
                                            item.state == 0
                                              ? _c(
                                                  "span",
                                                  { staticClass: "orangeFont" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          Number(
                                                            (
                                                              p.toCPrice *
                                                              p.number *
                                                              _vm.getBetweenDay(
                                                                [
                                                                  p.startDate,
                                                                  p.endDate,
                                                                ]
                                                              )
                                                            ).toFixed(2)
                                                          )
                                                        ) +
                                                        _vm._s(p.currency) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "span",
                                                  { staticClass: "orangeFont" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          p.toCPrice *
                                                            p.number *
                                                            (_vm.getBetweenDay([
                                                              p.startDate,
                                                              p.endDate,
                                                            ]) +
                                                              1)
                                                        ) +
                                                        _vm._s(p.currency) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                            p.toCPrice && p.toCPrice > 0
                                              ? _c("span", [
                                                  _c("span", [_vm._v("利润")]),
                                                  item.state == 0
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "orangeFont",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                Number(
                                                                  (
                                                                    (p.toCPrice -
                                                                      p.price) *
                                                                    p.number *
                                                                    _vm.getBetweenDay(
                                                                      [
                                                                        p.startDate,
                                                                        p.endDate,
                                                                      ]
                                                                    )
                                                                  ).toFixed(2)
                                                                )
                                                              ) +
                                                              _vm._s(
                                                                p.currency
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "orangeFont",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                (p.toCPrice -
                                                                  p.price) *
                                                                  p.number *
                                                                  (_vm.getBetweenDay(
                                                                    [
                                                                      p.startDate,
                                                                      p.endDate,
                                                                    ]
                                                                  ) +
                                                                    1)
                                                              ) +
                                                              _vm._s(
                                                                p.currency
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                ])
                                              : _vm._e(),
                                          ])
                                        : _vm._e(),
                                      p.remark != "" &&
                                      _vm.productObj.state != 4
                                        ? _c(
                                            "label",
                                            {
                                              staticStyle: {
                                                "font-size": "0.12rem",
                                                color: "#155969",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " 备注：" +
                                                  _vm._s(p.remark) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      p.remark != "" &&
                                      _vm.productObj.state == 4
                                        ? _c(
                                            "label",
                                            {
                                              staticStyle: {
                                                "font-size": "0.12rem",
                                                color: "#155969",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " 菜品说明：" +
                                                  _vm._s(p.remark) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    2
                                  )
                                }),
                                _c(
                                  "p",
                                  { staticStyle: { "margin-top": "0.06rem" } },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass: "productPriceButtom",
                                        on: {
                                          click: function ($event) {
                                            return _vm.openPricePoliceDetail(
                                              item,
                                              "info1"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("预定说明")]
                                    ),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "productPriceButtom",
                                        staticStyle: { "margin-left": "5px" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.openPricePoliceDetail(
                                              item,
                                              "info2"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("费用说明")]
                                    ),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "productPriceButtom",
                                        staticStyle: { "margin-left": "5px" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.openPricePoliceDetail(
                                              item,
                                              "info3"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("使用说明")]
                                    ),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "productPriceButtom",
                                        staticStyle: { "margin-left": "5px" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.openPricePoliceDetail(
                                              item,
                                              "info4"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("退改说明")]
                                    ),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "productPriceButtom",
                                        staticStyle: { "margin-left": "5px" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.openPricePoliceDetail(
                                              item,
                                              "info5"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("其他说明")]
                                    ),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "productPriceButtom",
                                        staticStyle: { "margin-left": "5px" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.openSpecialNoteDialog(
                                              item
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("特别说明")]
                                    ),
                                  ]
                                ),
                              ],
                              2
                            ),
                          ]
                        )
                      }
                    ),
                    0
                  )
                : _c(
                    "div",
                    { staticClass: "hiden_item" },
                    [
                      _c(
                        "p",
                        {
                          staticStyle: {
                            "padding-top": "10px",
                            "font-size": "14px",
                            "padding-left": "21px",
                            "line-height": "25px",
                          },
                        },
                        _vm._l(
                          _vm.productObj.airBudgetRequests,
                          function (item, index) {
                            return _c("label", { key: index }, [
                              item.trafficType != ""
                                ? _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "rgb(230, 74, 25)",
                                      },
                                    },
                                    [_vm._v(_vm._s(item.trafficType))]
                                  )
                                : _vm._e(),
                              _c("span", [
                                _vm._v(
                                  _vm._s(item.startCityName) +
                                    "-" +
                                    _vm._s(item.endCityName) +
                                    " 参考:" +
                                    _vm._s(item.flightNumber) +
                                    " "
                                ),
                              ]),
                              _c(
                                "span",
                                { staticStyle: { color: "#959090" } },
                                [_vm._v("出发")]
                              ),
                              _c("span", { staticClass: "inlineword" }, [
                                _vm._v(
                                  _vm._s(item.startAirport) +
                                    " " +
                                    _vm._s(
                                      _vm.dateFormat3(item.startDate, ".")
                                    ) +
                                    " " +
                                    _vm._s(item.startTime) +
                                    " " +
                                    _vm._s(item.startTerminal)
                                ),
                              ]),
                              _c(
                                "span",
                                { staticStyle: { color: "#959090" } },
                                [_vm._v("抵达")]
                              ),
                              _c("span", { staticClass: "inlineword" }, [
                                _vm._v(
                                  _vm._s(item.endAirport) +
                                    " " +
                                    _vm._s(_vm.dateFormat3(item.endDate, ".")) +
                                    " " +
                                    _vm._s(item.endTime) +
                                    " " +
                                    _vm._s(item.endTerminal)
                                ),
                              ]),
                              index !=
                              _vm.productObj.airBudgetRequests.length - 1
                                ? _c("span", { staticClass: "shuxian" }, [
                                    _vm._v("|"),
                                  ])
                                : _vm._e(),
                            ])
                          }
                        ),
                        0
                      ),
                      _vm._l(
                        _vm.productObj.detailResponses,
                        function (item, index) {
                          return _c("div", { key: index }, [
                            _c(
                              "div",
                              { staticStyle: { "min-width": "80px" } },
                              [
                                _c(
                                  "p",
                                  {
                                    staticStyle: {
                                      position: "relative",
                                      top: "-10px",
                                      "margin-top": "0px",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-checkbox",
                                      { staticStyle: { "margin-top": "15px" } },
                                      [
                                        _c("span", [
                                          _vm._v(_vm._s(item.productRoomName)),
                                        ]),
                                        _c("span", [
                                          _vm._v(_vm._s(item.productDesc)),
                                        ]),
                                        _c(
                                          "label",
                                          {
                                            staticStyle: {
                                              color: "#E64A19",
                                              "font-size": "14px",
                                            },
                                          },
                                          [_vm._v(" 报价 ")]
                                        ),
                                        _c("span", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                item.detailDateResponces[0]
                                                  .price
                                              ) +
                                              " " +
                                              _vm._s(
                                                item.detailDateResponces[0]
                                                  .currency
                                              ) +
                                              "/" +
                                              _vm._s(
                                                item.detailDateResponces[0]
                                                  .company
                                              ) +
                                              " "
                                          ),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                item.detailDateResponces[0]
                                                  .number
                                              ) +
                                                _vm._s(
                                                  item.detailDateResponces[0]
                                                    .company
                                                )
                                            ),
                                          ]),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "margin-right": "-4px",
                                              },
                                            },
                                            [_vm._v("共")]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "orangeFont" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    item.detailDateResponces[0]
                                                      .price *
                                                      item
                                                        .detailDateResponces[0]
                                                        .number
                                                  ) +
                                                  _vm._s(
                                                    item.detailDateResponces[0]
                                                      .currency
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "p",
                                  {
                                    staticStyle: {
                                      "margin-top": "0px",
                                      "margin-left": "21px",
                                    },
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass: "productPriceButtom",
                                        on: {
                                          click: function ($event) {
                                            return _vm.openPricePoliceDetail(
                                              item,
                                              "info1"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("退票说明")]
                                    ),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "productPriceButtom",
                                        staticStyle: { "margin-left": "5px" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.openPricePoliceDetail(
                                              item,
                                              "info2"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("改期说明")]
                                    ),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "productPriceButtom",
                                        staticStyle: { "margin-left": "5px" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.openPricePoliceDetail(
                                              item,
                                              "info3"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("航司备注")]
                                    ),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "productPriceButtom",
                                        staticStyle: { "margin-left": "5px" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.openPricePoliceDetail(
                                              item,
                                              "info4"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("航司积分")]
                                    ),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "productPriceButtom",
                                        staticStyle: { "margin-left": "5px" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.openPricePoliceDetail(
                                              item,
                                              "info5"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("签转说明")]
                                    ),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "productPriceButtom",
                                        staticStyle: { "margin-left": "5px" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.openPricePoliceDetail(
                                              item,
                                              "info5"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("行李额")]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ])
                        }
                      ),
                      _c(
                        "p",
                        {
                          staticStyle: {
                            "margin-top": "12px",
                            "margin-left": "21px",
                            "line-height": "20px",
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "10px",
                                color: "#4F6D7D",
                                "margin-right": "10px",
                              },
                            },
                            [
                              _vm._v(
                                "备注：" + _vm._s(_vm.productObj.introduce)
                              ),
                            ]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "shuxian",
                              staticStyle: { top: "-1px" },
                            },
                            [_vm._v("|")]
                          ),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "10px",
                                color: "#4F6D7D",
                              },
                            },
                            [
                              _vm._v(
                                " Option " +
                                  _vm._s(
                                    _vm.dateFormat3(
                                      _vm.productObj.detailResponses[0]
                                        .optionDate,
                                      "."
                                    )
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm.dateFormat4(
                                      _vm.productObj.detailResponses[0]
                                        .optionDate
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "shuxian",
                              staticStyle: { top: "-1px" },
                            },
                            [_vm._v("|")]
                          ),
                          _vm._l(
                            _vm.productObj.airBudgetRequests,
                            function (item, index) {
                              return _c(
                                "span",
                                {
                                  key: index,
                                  staticStyle: {
                                    "font-size": "10px",
                                    color: "#4F6D7D",
                                  },
                                },
                                [
                                  item.remark != ""
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(item.trafficType) +
                                            "参考车次备注:" +
                                            _vm._s(item.remark) +
                                            " "
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              )
                            }
                          ),
                        ],
                        2
                      ),
                    ],
                    2
                  ),
              _c("div", { staticClass: "buttonBox" }, [
                _c("i", {
                  staticClass: "el-icon-caret-top",
                  on: {
                    click: function ($event) {
                      _vm.productObj.isOpen = false
                    },
                  },
                }),
              ]),
            ]
          ),
        ],
        1
      ),
      _c("policyDetailPopup", { ref: "policyDetailPopup" }),
      _c("create-refer-product-dialog", {
        ref: "createProduct",
        attrs: { keyStr: _vm.keyStr },
      }),
      _c("add-special-note-popup", {
        ref: "addSpecialNotePopup",
        on: { "save-success": _vm.handleSpecialNoteSaved },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": true,
            "modal-append-to-body": true,
            visible: _vm.dialogLinkVisible,
            title: "关联已加入产品",
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogLinkVisible = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData, "tooltip-effect": "dark" },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { label: "日期", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          _vm._s(_vm.dateFormatYMD(scope.row.stayDate, "-"))
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "资源名称",
                  prop: "resourceNameCn",
                  width: "200",
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogLinkVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addLinkSure } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }